import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {DataGrid} from './DataGrid';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

export const Title = styled.div`
  flex: 2;
`;

export const ContentContainer = styled.div`
  background: rgba(255, 255, 255, 0.95);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 1em 20px;
`;

// Wrapper component for our custom DataGrid
export const StyledTable = (props) => (
  <DataGrid {...props} />
);

StyledTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  onRowClick: PropTypes.func,
};
